import { layout } from 'thewest/App.routing'

export const insideCoverSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        layoutRatio: '1:3',
        stretchColumns: true,
        verticalSpacing: 'xl',
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'section-header',
                props: {
                    heading: 'Promotional',
                    hasMargin: true,
                    invisibleHeaderBreakpoint: 'md',
                },
            }),

            layout.component({
                type: 'promotional-card',
                props: {
                    fixedRatio: '4:3',
                    hasBackground: true,
                    hasPadding: true,
                    mediaMode: 'edgeToEdge',
                    fontScale: 0.88,
                    showCTA: true,
                    cardOrientation: {
                        defaultLayout: 'landscape',
                        alternativeLayoutOptions: {
                            breakpoint: 'md',
                            layout: 'portrait',
                        },
                    },
                    verticalSpacing: 'md',
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'promotional-cards',
                        offset: 3,
                        pageSize: 1,
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    fixedRatios: ['16:9'],
                    intermediateColumns: 3,
                    finalColumns: 3,
                    hideTeaser: false,
                    hideByline: false,
                    hasBackground: true,
                    cardOrientation: { type: 'Landscape-Portrait' },
                    cardLayout: [
                        ['teaserWithBackground'],
                        ['commonWithBackground', 'titleOnly'],
                        ['commonWithBackground', 'titleOnly'],
                    ],
                    sectionHeader: {
                        heading: 'Inside Cover',
                        headingUrl: '/opinion/inside-cover',
                        section: 'opinion',
                    },
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'inside-cover',
                        offset: 0,
                        pageSize: 5,
                    },
                },
            }),
        ],
    },
})
